export default [{ "url": "http://msas4529i/maklerportalneu/api/user/courtage/20180731",
  "courtagedate": "2016-07-28T00:00:00",
  "creationdate": "2016-08-29T11:38:44.481495Z" }, {
  "url": "http://msas4529i/maklerportalneu/api/user/courtage/20180831",
  "courtagedate": "2017-07-28T00:00:00",
  "creationdate": "2017-08-29T11:38:44.6064926Z" },
  { "url": "http://msas4529i/maklerportalneu/api/user/courtage/20180731",
    "courtagedate": "2018-07-28T00:00:00",
    "creationdate": "2018-08-29T11:38:44.481495Z" }, {
    "url": "http://msas4529i/maklerportalneu/api/user/courtage/20180831",
    "courtagedate": "2015-07-28T00:00:00",
    "creationdate": "2015-08-29T11:38:44.6064926Z" },
  { "url": "http://msas4529i/maklerportalneu/api/user/courtage/20180731",
    "courtagedate": "2016-08-28T00:00:00",
    "creationdate": "2016-08-29T11:38:44.481495Z" }, {
    "url": "http://msas4529i/maklerportalneu/api/user/courtage/20180831",
    "courtagedate": "2017-08-28T00:00:00",
    "creationdate": "2017-08-29T11:38:44.6064926Z" },
  { "url": "http://msas4529i/maklerportalneu/api/user/courtage/20180731",
    "courtagedate": "2018-08-28T00:00:00",
    "creationdate": "2018-08-29T11:38:44.481495Z" }, {
    "url": "http://msas4529i/maklerportalneu/api/user/courtage/20180831",
    "courtagedate": "2018-05-28T00:00:00",
    "creationdate": "2018-05-29T11:38:44.6064926Z" },
  { "url": "http://msas4529i/maklerportalneu/api/user/courtage/20180731",
    "courtagedate": "2017-05-28T00:00:00",
    "creationdate": "2017-06-29T11:38:44.481495Z" }, {
    "url": "http://msas4529i/maklerportalneu/api/user/courtage/20180831",
    "courtagedate": "2016-05-28T00:00:00",
    "creationdate": "2016-06-29T11:38:44.6064926Z" }];
